import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class RefundApi {
  getRefunds = async (params) => {
    try {
      const response = await api.get("/refund", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Refund(s). Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateRefundStatus = async (stallEnquiryId, data) => {
    try {
      const response = await api.put(`/refund/${stallEnquiryId}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Refund Status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
}

const refundApi = new RefundApi();
export default refundApi;

export const {
  getRefunds,
  updateRefundStatus,
} = refundApi;
